import { useEffect } from 'react';

export const editorialArticleUrl = (slug) => `/marketplace-admin/noticias/preview/${slug}`;
export const editorialAdminUrl = '/marketplace-admin#noticias-info';
export const editorialLegalUrl = '/marketplace-admin/noticias/legislacao';

export const editorialDate = (date) => date ? date.slice(0, 10).split('-').reverse().join('/') : '';

export const useEditorialPreview = (preview) => {
  useEffect(() => {
    if (!preview) return undefined;
    const previous = document.querySelector('meta[name="robots"]');
    const oldContent = previous?.content;
    const meta = previous || document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow, noarchive';
    if (!previous) document.head.appendChild(meta);
    return () => { if (previous) meta.content = oldContent; else meta.remove(); };
  }, [preview]);
};